/** The release this bundle is, as Vite stamped it at build (vite.config.ts). */
export const APP_VERSION: string = __APP_VERSION__;
/** The short sha the deploy built it from; empty for a build without git. */
export const APP_COMMIT: string = __APP_COMMIT__;
